/* ============================================================
 * RVRN Hero Collection — Section 5
 *
 * Handles: grid density toggle (4/5 desktop, 1/2 mobile),
 * load-more pagination with lazy image loading.
 * ============================================================ */

(() => {
  const GRID_STORAGE_KEY = 'rvrn-hc-grid-columns';
  const MOBILE_GRID_STORAGE_KEY = 'rvrn-hc-grid-columns-mobile';

  document.querySelectorAll('.rvrn-hc').forEach(section => {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    /* ========================================================
     * Grid density toggle (desktop 4/5, mobile 1/2)
     * ======================================================== */
    const desktopBtns = section.querySelectorAll('.rvrn-hc__grid-density:not(.rvrn-hc__grid-density--mobile) .rvrn-hc__grid-density-btn');
    const mobileBtns = section.querySelectorAll('.rvrn-hc__grid-density--mobile .rvrn-hc__grid-density-btn');
    const grid = section.querySelector('.rvrn-hc__grid');

    let desktopCols = 4;
    let mobileCols = 1;

    if (grid) {
      /* Restore persisted preferences */
      try {
        const savedDesktop = Number(localStorage.getItem(GRID_STORAGE_KEY));
        if (savedDesktop === 4 || savedDesktop === 5) desktopCols = savedDesktop;
        const savedMobile = Number(localStorage.getItem(MOBILE_GRID_STORAGE_KEY));
        if (savedMobile === 1 || savedMobile === 2) mobileCols = savedMobile;
      } catch (e) { /* ignore */ }

      function applyGridDensity() {
        grid.setAttribute('data-grid-columns', String(desktopCols));
        grid.setAttribute('data-grid-columns-mobile', String(mobileCols));

        /* Update product cards for 5-col density */
        grid.querySelectorAll('.rvrn-product-card').forEach(card => {
          card.setAttribute('data-grid-columns', String(desktopCols));
        });

        /* Update button active states */
        desktopBtns.forEach(btn => {
          const cols = Number(btn.getAttribute('data-grid-columns'));
          const isActive = cols === desktopCols;
          btn.setAttribute('aria-pressed', String(isActive));
          btn.classList.toggle('is-active', isActive);
        });
        mobileBtns.forEach(btn => {
          const cols = Number(btn.getAttribute('data-grid-columns-mobile'));
          const isActive = cols === mobileCols;
          btn.setAttribute('aria-pressed', String(isActive));
          btn.classList.toggle('is-active', isActive);
        });
      }

      applyGridDensity();

      /* Desktop density buttons */
      desktopBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const cols = Number(btn.getAttribute('data-grid-columns'));
          if (cols === desktopCols) return;
          desktopCols = cols;
          applyGridDensity();
          try { localStorage.setItem(GRID_STORAGE_KEY, String(cols)); } catch (e) {}
        });
      });

      /* Mobile density buttons */
      mobileBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const cols = Number(btn.getAttribute('data-grid-columns-mobile'));
          if (cols === mobileCols) return;
          mobileCols = cols;
          applyGridDensity();
          try { localStorage.setItem(MOBILE_GRID_STORAGE_KEY, String(cols)); } catch (e) {}
        });
      });
    }

    /* ========================================================
     * Load More / Show Less
     * ======================================================== */
    const loadMoreBtn = section.querySelector('[data-load-more]');
    const showLessBtn = section.querySelector('[data-show-less]');
    if (!loadMoreBtn) return;

    const totalProducts = Number(section.dataset.totalProducts) || 0;
    const maxProducts = Number(section.dataset.maxProducts) || 8;
    const labelPattern = loadMoreBtn.dataset.labelPattern || 'Show';
    let visibleCount = maxProducts;

    /* All product cards in order */
    const allCards = Array.from(section.querySelectorAll('.rvrn-hc__product'));

    /* Hidden cards (those beyond initial max) */
    const hiddenCards = allCards.slice(maxProducts);

    function lazyLoadImage(img) {
      if (img.classList.contains('is-loaded')) return;
      const src = img.getAttribute('data-src');
      const srcset = img.getAttribute('data-srcset');
      if (!src) return;

      img.src = src;
      if (srcset) img.srcset = srcset;
      img.removeAttribute('data-src');

      if (img.complete) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
      }
    }

    function updateLoadMoreLabel() {
      const remaining = totalProducts - visibleCount;
      loadMoreBtn.textContent = `${labelPattern} ${remaining} More`;
    }

    function toggleButtons() {
      if (visibleCount >= totalProducts) {
        loadMoreBtn.hidden = true;
        showLessBtn.hidden = false;
      } else {
        loadMoreBtn.hidden = false;
        showLessBtn.hidden = true;
      }
    }

    /* Load More */
    loadMoreBtn.addEventListener('click', () => {
      const batchSize = maxProducts;
      const nextVisible = Math.min(visibleCount + batchSize, totalProducts);
      const batch = hiddenCards.slice(
        visibleCount - maxProducts,
        nextVisible - maxProducts
      );

      batch.forEach(card => {
        card.hidden = false;
        card.classList.remove('rvrn-hc__product--hidden');
        card.querySelectorAll('.rvrn-product-card__image[data-src]').forEach(lazyLoadImage);
      });

      visibleCount = nextVisible;
      updateLoadMoreLabel();
      toggleButtons();
    });

    /* Show Less */
    showLessBtn.addEventListener('click', () => {
      /* Hide all cards beyond initial max */
      allCards.slice(maxProducts).forEach(card => {
        card.hidden = true;
        card.classList.add('rvrn-hc__product--hidden');
      });

      visibleCount = maxProducts;
      updateLoadMoreLabel();
      toggleButtons();
    });
  });
})();
